import React, { useEffect } from "react";
import {
  Box,
  Flex,
  Grid,
  GridItem,
} from "@chakra-ui/react";
import MembershipPieChart from "../components/MembershipPieChart";
import { useDispatch, useSelector } from "react-redux";
import { fetchMembershipDashboard } from "../redux/slices/dashboardSlice";
import MembershipDashboardBarChart from "../components/MembershipDashboardBarChart";
import DashboardDisplayCards from "../components/DashboardDisplayCards";
import img1 from "../Assets/Images/dcard-image-1.png";
import img2 from "../Assets/Images/dcard-image-2.png";
import img3 from "../Assets/Images/dcard-image-3.png";
import img4 from "../Assets/Images/dcard-image-4.png";
import AdminDashboardExamReport from "../components/AdminDashboardExamReport";
import DashboardActivityBarChart from "../components/DashboardActivityBarCharts";


const MembershipOMDashboard = () => {
  const dispatch = useDispatch();
  const membershipDashboardData = useSelector(
    (state) => state?.dashboard?.membershipDashboard
  );

  useEffect(() => {
    dispatch(fetchMembershipDashboard());
  }, [dispatch]);

  const details = [
    {
      name: "Total Number Of Students",
      number: membershipDashboardData?.memberCategoryCounts?.totalStudent,
      bgcolor: "#FFF6EC",
      icon: img1,
      imgBgColor: "#FFE9BC",
    },
    {
      name: "Total Number Of NYSC Members",
      number: membershipDashboardData?.memberCategoryCounts?.totalNYSC,
      bgcolor: "#FCEAE4",
      icon: img2,
      imgBgColor:"#F8D4C8"
    },
    {
      name: "Total Number Of Graduates",
      number: membershipDashboardData?.memberCategoryCounts?.totalGraduate,
      bgcolor: "#EFE6F6",
      icon: img3,
      imgBgColor:"#E7D1F8"
    },
    {
      name: "Total Number Of Fellows",
      number: membershipDashboardData?.memberCategoryCounts?.totalFellow,
      bgcolor: "#FFECF0",
      icon: img1,
      imgBgColor:"#F4BCCA"
    },
    {
      name: "Total Number Of Associates",
      number: membershipDashboardData?.memberCategoryCounts?.totalAssociate,
      bgcolor: "#EDF2FB",
      icon: img4,
      imgBgColor:"#416EFC4A"
    },
    
  ];

  const memberStats = membershipDashboardData?.memberReport;

  const totalMembers = memberStats?.totalMembers || 0;
  const totalNonMembers = memberStats?.totalNonMembers || 0;
  const totalOldMembers = memberStats?.totalOldMembers || 0;

  const memberReportData = {
    title: "Member Report",
    color1: "#F86624",
    color2: "#22CAAD",
    color3: "#EB3D4D",
    text1: "Total Members",
    text2: "Total Non-Members",
    text3: "Total Old Members",
    value1: totalMembers.toLocaleString(),
    value2: totalNonMembers.toLocaleString(),
    value3: totalOldMembers.toLocaleString(),
  };
  

  return (
    <Flex
      flexDirection={"column"}
      gap={"20px"}
      py={"30px"}
      minH={"100vh"}
      px={3}
    >
      <Flex
        flexDirection={["column", "column", "column", "row"]}
        justifyContent={["center", "center", "flex-start"]}
        alignItems={"center"}
        gap={"20px"}
      >
        <Box w={["100%", "100%", "100%"]} bgColor={"#FFFFFF"} borderRadius={"14px"} border={"1px solid #E3EBEE"} padding={"20px"}>
          <Grid gridTemplateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)","repeat(3, 1fr)","repeat(4, 1fr)", "repeat(5, 1fr)"]} gap={5}>
          {
            details?.map((detail, index) => (
              <GridItem>
                <DashboardDisplayCards key={index} {...detail} />
              </GridItem>
            ))
          }
          </Grid>
        </Box>
      </Flex>
      <Flex
        alignItems={["center", "center", "flex-start"]}
        flexDirection={["column", "column", "column", "row"]}
        justifyContent={["center", "center", "flex-start"]}
        gap={"20px"}
      >
        <Flex
          flexDirection={"column"}
          w={["100%", "100%", "100%", "70%", "75%"]}
          gap={5}
        >
          <MembershipDashboardBarChart membershipbarChartData={membershipDashboardData?.memberUpgradePerMonth} />
        </Flex>
        <Box width={["100%", "100%", "100%", "30%", "25%"]}>
          <MembershipPieChart membershippieChartData={membershipDashboardData?.memberUpgradeByCategory} />
        </Box>
      </Flex>
      <DashboardActivityBarChart barChartData={membershipDashboardData?.activityReports} />
      <AdminDashboardExamReport {...memberReportData} />
    </Flex>
  );
};

export default MembershipOMDashboard;
